import './style/loginPopup.scss';

import {
    ChangeFunction, CloseButton, DvrdButton, DvrdInput, DVRDPasswordInput, ErrorType, Loader, preventDefault,
    WithBackground
} from '@dvrd/dvr-controls';
import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler, useContext, useMemo} from 'react';
import {AppContext} from "../../context/appContext";
import classNames from 'classnames';

interface Props {
    onClose: MouseEventHandler;
    onChangeEmail: ChangeFunction<string>;
    onChangePassword: ChangeFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onLogout: MouseEventHandler;
    onResetError: FocusEventHandler;
    open: boolean;
    email: string;
    password: string;
    loading: boolean;
    error: ErrorType;
}

export default function LoginPopup(props: Props) {
    const {user} = useContext(AppContext).userContext;
    const {
        onClose, onChangeEmail, onChangePassword, onSubmit, onLogout, onResetError, email, password, loading, error,
        open
    } = props;
    const title = useMemo(() => {
        if (!!user) return 'Ingelogd';
        return 'Inloggen';
    }, [user]);

    function renderBody() {
        if (!!user) return renderLogoutBody();
        return renderLoginBody();
    }

    function renderLoginBody() {
        return (
            <form className='body-container login' onSubmit={preventDefault}>
                <Loader active={loading}/>
                <DvrdInput value={email} onChange={onChangeEmail} label='E-mailadres' placeholder='E-mailadres'
                           inputProps={{autoComplete: 'username'}} onEnter={onSubmit} onFocus={onResetError}/>
                <DVRDPasswordInput value={password} onChange={onChangePassword} label='Wachtwoord'
                                   placeholder='Wachtwoord' inputProps={{autoComplete: 'current-password'}}
                                   onEnter={onSubmit} onFocus={onResetError}/>
                <label className={classNames('error-label', !!error && 'error')}>{error}</label>
            </form>
        );
    }

    function renderLogoutBody() {
        return (
            <div className='body-container logout'>
                <Loader active={loading}/>
                <DvrdButton onClick={onLogout} label='Uitloggen'/>
            </div>
        )
    }

    function renderFooter() {
        if (!!user) return (
            <div className='footer-container'>
                <DvrdButton onClick={onClose} label='Sluiten' disabled={loading} secondary/>
            </div>
        );
        return (
            <div className='footer-container btn-2'>
                <DvrdButton onClick={onClose} label='Sluiten' disabled={loading} secondary/>
                <DvrdButton onClick={onSubmit} label='Inloggen' disabled={loading}/>
            </div>
        )
    }

    return (
        <WithBackground active={open} onClose={onClose}>
            <div className='default-popup login-popup'>
                <div className='header-container'>
                    <label className='header-title'>{title}</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                {renderFooter()}
            </div>
        </WithBackground>
    )
}